import React from 'react';
import ProgressLine from '../../../../Common/ProgressLine/ProgressLine';
import { useTranslation } from 'react-i18next';
import styles from './SignUpStepProgressLayout.module.scss';
import { SIGN_UP_STEPS_COUNT } from '../../../../../common/constants';

interface Props extends JSX.ElementChildrenAttribute {
  step: number
}

function SignUpStepProgressLayout(props: Props) {
  const { step, children } = props;
  const { t } = useTranslation();
  return (
    <div>
      <div className={styles.header}>
        <ProgressLine
          label={t('signup.progress.label', { step, count: SIGN_UP_STEPS_COUNT})}
          step={step}
          count={SIGN_UP_STEPS_COUNT}
        />
      </div>
      { children }
    </div>
  )
}

export default SignUpStepProgressLayout;
